import React from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import useAntTable from "../../../../utils/useAntTable";
import * as api from "../../../../apis/platforms/admin/financeWriteOff";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import withAuth from "../../../../utils/withAuth";
import {Button, Space} from "antd";
import dayjs from "dayjs";
import {useHistory} from "react-router-dom";

const ImportButton = withAuth('import', Button)

export default function FinanceWriteOff() {

    const history = useHistory()
    const {tableProps, search, form} = useAntTable(api.getFinanceWriteOffList, {method: "post"})

    const columns = [
        {
            title: '核销单号',
            dataIndex: 'writeOffNo'
        },
        {
            title: '客户名称',
            dataIndex: 'dealerName'
        },
        {
            title: '核销日期',
            dataIndex: 'writeOffDate',
            render: (value: any) => dayjs(value).format('ll')

        },
        {
            title: '核销金额',
            dataIndex: 'writeOffAmountTotal'
        },
        {
            title: '类型',
            dataIndex: 'type',
            render: (value: number) => value === 0 ? '手动' : '自动'
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: (value: number) => value === 0 ? '未审核' : '已审核'
        },
        {
            title: '操作',
            dataIndex: 'operation',
            render: (__: any, record: any) => (
                <span>
                    <a onClick={() => history.push(`/finance/writeOff/detail/${record.id}`)}>详情</a>
                </span>
            )
        }
    ]

    const extSearchColumns: StandardColumnsType = [
        {
            dataIndex: 'writeOffNo',
            title: '单号',
            search: {
                colSpan: 6
            }
        },
        {
            dataIndex: 'dealer',
            title: '客户名称或编号',
            search: {
                colSpan: 6
            }
        },
        {
            dataIndex: 'status',
            title: '状态',
            search: {
                valueType: 'select',
                valueEnum: [
                    {value: 0, text: '未审核'},
                    {value: 1, text: '已审核'},
                ],
                colSpan: 6
            }
        }
    ];

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} extSearchColumns={extSearchColumns}
                           search={search} form={form} toolbar={
                <Space>
                    <ImportButton type={"primary"}>导入</ImportButton>
                </Space>
            }/>
        </PageHeaderLayout>
    )
}
